export const images = {
  welcome_background: require('./welcome-background.png'),
}